export const modalTheme = {
    overlay: {
        zIndex: 9000,
        background: (props) => props.theme.palette.overlayDark2,
    },
    fadeDuration: 300,
    wrapperPaddingVariant: {
        md: {
            wrapper: { padding: (props) => props.theme.spacing.md },
        },
        none: { wrapper: { padding: '0' } },
    },
};
export const wrapperPaddingVariant = (props) => modalTheme.wrapperPaddingVariant[props.wrapperPadding ?? 'md'];
